import { GetStaticProps } from 'next';

import client from '@utils/apolloClient';
import { getPostItemBySlug } from '@queries/posts.graphql';

import Article from '@components/Article/Article';
import Description from '@components/Description/Description';
import Layout from '@components/Layout/Layout';
import Strapline from '@components/Strapline/Strapline';
import Title from '@components/Title/Title';

type IndexProps = {
  body: string;
  featureFlags: any;
  siteTitle: string;
  strapline: string;
  title: string;
};

const PrivacyPolicy = ({
  body,
  featureFlags,
  siteTitle,
  strapline,
  title,
}: IndexProps) => {
  return (
    <Layout
      featureFlags={featureFlags}
      pageTitle={title}
      pageType="website"
      section="Home"
      siteTitle={siteTitle}
      url="/privacy-policy"
    >
      <Article.ContentWrapper>
        <Title>{title}</Title>
        <Strapline text={strapline} />
        <Description content={body} />
      </Article.ContentWrapper>
    </Layout>
  );
};

export default PrivacyPolicy;

export const getStaticProps: GetStaticProps = async () => {
  const configData = await import(`../siteconfig.json`);

  const {
    data: { PostItem: page },
  } = await client.query({
    query: getPostItemBySlug,
    variables: {
      slug: 'privacy-policy',
    },
  });

  return {
    props: {
      body: page.content.body,
      featureFlags: configData.featureFlags,
      strapline: page.content.strapline,
      title: page.title,
      siteTitle: configData.default.title,
    },
  };
};
